import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdentityComponent } from '@app/identity/identity.component';
import { IdentityRoutingModule } from '@app/identity/identity-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';


import {MaskPipe} from '@app/mask.pipe';
import { PopupComponent } from '@app/popup/popup.component';
import { NgxMaskModule } from '../../../node_modules/ngx-mask';


@NgModule({
  imports: [
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskModule,
    IdentityRoutingModule
  ],
  declarations: [IdentityComponent,MaskPipe]
 
})
export class IdentityModule { }
